import { render, staticRenderFns } from "./ElInputFigure.vue?vue&type=template&id=67db4f0e"
import script from "./ElInputFigure.vue?vue&type=script&lang=js"
export * from "./ElInputFigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports